import React, { useState } from 'react';
import Logo from '../assets/logo.png';
import './mantenimiento.css';

/**
 * Pantalla que se muestra cuando la aplicación está en mantenimiento.
 * Solo es presentacional; la decisión de mostrarla la toma MantenimientoGate.
 * Si se recibe una URL válida en `imagen_web`, se muestra dicha imagen.
 * Si `imagen_web` está vacía o falla la carga, muestra el mensaje institucional con canales alternativos.
 */
const Mantenimiento = ({ imagen_web, imagenWeb }) => {
    const srcImagen = (imagen_web || imagenWeb || '').trim();
    const [imgError, setImgError] = useState(false);

    const mostrarImagen = Boolean(srcImagen) && !imgError;

    return (
        <div className='mantenimiento'>
            {mostrarImagen ? (
                <div className='mantenimiento__imagen-wrapper'>
                    <img
                        className='mantenimiento__imagen'
                        src={srcImagen}
                        alt="Sitio en mantenimiento"
                        onError={() => setImgError(true)}
                    />
                </div>
            ) : (
                <div className='mantenimiento__card'>
                    <img className='mantenimiento__logo' src={Logo} alt="Valmex" />

                    <h1 className='mantenimiento__titulo'>Sitio en mantenimiento</h1>

                    <p>Estimados Clientes,</p>
                    <p>Nos dirigimos a ustedes para informarles que nuestro sitio web se encuentra actualmente en mantenimiento. Esta acción es parte de nuestro compromiso constante de trabajar para ustedes y mejorar la calidad de nuestros servicios.</p>
                    <p>Agradecemos su comprensión y paciencia durante este período. Mientras tanto, pueden continuar realizando sus consultas y operaciones a través de los siguientes canales alternativos:</p>

                    <ul className='mantenimiento__canales'>
                        <li>
                            <b>Portal de consulta de Valmex Casa de Bolsa</b>
                            <a href='https://servicios.valmex.com.mx/Cuenta/Ingreso' target='_blank' rel='noopener noreferrer'>https://servicios.valmex.com.mx/Cuenta/Ingreso</a>
                        </li>
                        <li>
                            <b>Página anterior de Valmex SI</b>
                            <a href='https://valmexsi.valmex.com.mx/' target='_blank' rel='noopener noreferrer'>https://valmexsi.valmex.com.mx/</a>
                        </li>
                        <li>
                            <b>Asesor personal</b>
                            También pueden contactar directamente a su asesor para cualquier consulta o requerimiento.
                        </li>
                    </ul>

                    <p>Nuestro equipo está trabajando arduamente para restablecer el servicio lo antes posible y seguir ofreciéndoles la mejor experiencia.</p>
                    <p>Gracias por su comprensión y confianza.</p>

                    <div className='mantenimiento__firma'>
                        <p>Atentamente,</p>
                        <p><b>Valmex Casa de Bolsa</b></p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Mantenimiento;
